import { useExonnHubContext } from "src/admin/modules/b2b-gate-order/components/ExonnHub/useExonnHubContext.ts";

export const useExonnHubStore = () => {
  const context = useExonnHubContext();

  return context.store;
};
